import React from 'react';

const Switch = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="4" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M8.64024 3.63223C9.0645 3.98582 9.12179 4.61638 8.7682 5.04064L7.1352 7.00003H15C15.5523 7.00003 16 7.44774 16 8.00003C16 8.55231 15.5523 9.00003 15 9.00003H5.00001C4.61198 9.00003 4.25899 8.77555 4.09441 8.42416C3.92984 8.07276 3.9834 7.65788 4.23183 7.3598L7.23183 3.76019C7.58541 3.33593 8.21598 3.27864 8.64024 3.63223Z"
            fill="#969FA8" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M11.3598 16.3678C10.9355 16.0142 10.8782 15.3836 11.2318 14.9594L12.8648 13H4.99999C4.4477 13 3.99999 12.5523 3.99999 12C3.99999 11.4477 4.4477 11 4.99999 11H15C15.388 11 15.741 11.2244 15.9056 11.5758C16.0702 11.9272 16.0166 12.3421 15.7682 12.6402L12.7682 16.2398C12.4146 16.6641 11.784 16.7214 11.3598 16.3678Z"
            fill="#969FA8" />
    </svg>

  );
};

export default Switch;
